import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio43: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"aspect-ratio-4-3, landscape"} maskId="square-filled-radius-0-stroke-1-IconAspectRatio43"><path d="M2 4V20H22V4H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAspectRatio43;
